import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const RedemProtectedRoute = ({ children }) => {
   const token = sessionStorage.getItem('token');
   const rcId = sessionStorage.getItem('userType');

   // If no token or not a driver
   if (!token || !rcId) {
      sessionStorage.clear();
      return <Navigate to="/redemption-login" replace />;
   }

   try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      // Token expired
      if (decoded.exp < currentTime) {
         sessionStorage.clear();
         return <Navigate to="/redemption-login" replace />;
      }
   } catch (err) {
      console.error('Driver token decode error:', err);
      sessionStorage.clear();
      return <Navigate to="/redemption-login" replace />;
   }

   return children;
};

export default RedemProtectedRoute;